export const CANVA_REDIRECT_ORIGIN = 'https://portal.elevator.tv';
export const CANVA_REDIRECT_URI = `${CANVA_REDIRECT_ORIGIN}/canva-popup`;
export const CANVA_CLIENT_ID = 'OC-AZQmWnVLXM7L';

const ALLOWED_APP_ORIGINS = new Set([
  CANVA_REDIRECT_ORIGIN,
  'https://portal2.elevator.tv',
  'https://elevatortvv2.web.app',
  'http://127.0.0.1:3000',
]);

export const isAllowedCanvaAppOrigin = (origin) => ALLOWED_APP_ORIGINS.has(origin);
